var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"active-reservations"},[_c('div',{staticClass:"title"},[_vm._v(" Aktivne Rezervacije ")]),_vm._l((_vm.displayedReservations),function(reservation){return _c('SingleActiveReservation',{key:reservation.id,attrs:{"reservation":reservation}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }